import moment from 'moment';

const charMap = JSON.parse(
  '{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\"","”":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}'
);

type SlugifyOptionsType = {
  remove?: string,
  replacement?: string,
  lower?: boolean
}

/**
 * https://github.com/simov/slugify/blob/master/index.js
 * Code under MIT license
 */
export function slugify(string: string, options: SlugifyOptionsType | string) {
  if (typeof string !== 'string') {
    throw new Error('slugify: string argument expected')
  }
  const sanitizedOptions: SlugifyOptionsType = (typeof options === 'string')
    ? {replacement: options}
    : options || {};
  let slug = string.split('')
    .reduce(function (result, ch) {
      return result + (charMap[ch] || ch)
        // allowed
        .replace(sanitizedOptions.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
    }, '')
    // trim leading/trailing spaces
    .trim()
    // convert spaces
    .replace(/[-\s]+/g, sanitizedOptions.replacement || '-')
    // remove trailing separator
    .replace('#{replacement}$', '');

  return sanitizedOptions.lower ? slug.toLowerCase() : slug;

}

export function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}


export function getRandomString(length: number) {
  let alphabet = 'abcdefghijklmopqrstuvwxyzABCDEFGHIJKLMOPQRSTUVWXYZ';
  let data = [];
  for (let i = 0; i < length; i++) {
    data.push(alphabet[Math.ceil(Math.random() * alphabet.length)]);
  }
  return data.join('');
}

/**
 * Sanitizes a certain arbitrary value so that we can use dom IDs for referencing it.
 * @param s
 * @returns {string}
 */
export function sanitizeValueForDomId(s: string): string {
  return s.replace(/[ /=]/g, '-');
}

export function isEmailFormat(email: string) {
  let re = /[a-zA-Z0-9.\-_+]+@[a-zA-Z0-9.\-_]+/;
  return re.test(email);
}

export function isJsonSchemaType(node: {type: string | string[]}, type: string) {
  if (!Array.isArray(node.type)) {
    return node.type === type
  } else {
    return node.type.includes(type)
  }
}

export function getBase64(file: File, onLoadFinish: (res: string | ArrayBuffer | null) => void) {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    onLoadFinish(reader.result);
  };
}

const CURRENCY_CORRECTIONS: { [key: string]: string } = {EURO: 'EUR'}

export function localizedPrice(currency: string, amount: number) {
  try {
    return new Intl.NumberFormat(navigator.language,
      {
        style: 'currency',
        currency: CURRENCY_CORRECTIONS[currency] || currency
      }).format(amount)
  } catch (e) {
    return `${amount} ${currency}`
  }
}

export function formatToPrice(value: string  | number | null | undefined) {
  if (value == null) {
    return "0,00"
  }

  let result = new Intl.NumberFormat("da").format(
    parseFloat(
      value.toString().replace(',', '.')
    )
  )

  if (result === "NaN") {
    return result
  }

  if (result.split(",").length === 1) {
    result = result + ",00"
  } else if (result.split(",")[1].length === 1) {
    result = result + "0"
  }

  return result
}

const ONE_KB = 1000;
const ONE_MB = 1000 * ONE_KB;
const ONE_GB = 1000 * ONE_MB;

function _formatFloatToTwoDecimals(f: number) {
  return "" + parseFloat(f.toFixed(2));
}

export function formatSize(value: number) {
  if (value <= ONE_KB) {
    return `${_formatFloatToTwoDecimals(value)} bytes`;
  } else if (value < ONE_MB) {
    return `${_formatFloatToTwoDecimals(value / ONE_KB)} KB`;
  } else if (value < ONE_GB) {
    return `${_formatFloatToTwoDecimals(value / ONE_MB)} MB`
  } else {
    return `${_formatFloatToTwoDecimals(value / ONE_GB)} GB`;
  }
}

export function isLinkImage(url: string | null | undefined) {
  if (typeof url !== 'string') {
    return false;
  }
  return (url.match(/^http[^\?]*.(jpg|jpeg|png|webp|avif|gif|svg)(\?(.*))?$/gmi) !== null);
}

export function isStartingWithVowel(string: string) {
  const vowels = ["a","e","i","o","u"];
  return vowels.includes(string.toLowerCase()[0]);
}

export function pluralizeByCount(string: string, input: number | any[]) {
  const count = Array.isArray(input) ? input.length : input;
  if(count === 1) {
    return string;
  }

  return `${string}s`;
}

export function normalizeDate(date: string, withOnPrefix?: boolean, removeCurrentYear?: boolean) {
  if(moment(date).format('D MMMM YYYY') === moment().format('D MMMM YYYY')) {
    return 'today';
  } else if(moment(date).add(1, 'days').format('D MMMM YYYY') === moment().format('D MMMM YYYY')) {
    return 'yesterday'
  }

  const isCurrentYear = moment(date).format('YYYY') === moment().format('YYYY')
  if(withOnPrefix) {
    if(removeCurrentYear && isCurrentYear) {
      return moment(date).format('[on] D MMMM');
    }

    return moment(date).format('[on] D MMMM YYYY');
  } else {
    if(removeCurrentYear && isCurrentYear) {
      return moment(date).format('D MMMM');
    }

    return moment(date).format('D MMMM YYYY');
  }
}

export function isIntegerString (val: any) {
  if (typeof val !== "string") {
    return false;
  }

  return !isNaN(parseInt(val)) && parseInt(val).toString() === val;
}

export function isNumeric (val: string | number, allowFloat = false) {
  if(typeof val === "number") {
    val = String(val)
  }

  if(!val || (allowFloat && val === ".")) {
    return false;
  }

  const digits = val.split("");
  let dotFound = false;

  for (let i = 0; i < digits.length; i++) {
    if (allowFloat && digits[i] === '.') {
      if (dotFound || i === 0 || i === digits.length - 1) {
        return false;
      }
      dotFound = true;
    } else if (digits[i] < '0' || digits[i] > '9') {
      return false;
    }
  }

  return true;
}

/**
 * Converts a string into a number by stripping out non-numeric characters.
 */
export function stringToNumber(str: string, options: {allowFloat?: boolean} = {}): number | null {
  const cleaned = options.allowFloat
    ? str.replace(/[^0-9.]/g, '')
    : str.replace(/[^0-9]/g, '');

  const num = options.allowFloat ? parseFloat(cleaned) : parseInt(cleaned, 10);

  return isNaN(num) ? null : num;
}
